const productionMode = process.env.NODE_ENV === "production";

const host = process.env.REACT_APP_API_HOST || "https://api.ooca.dev/";

const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBDeukae8M9Ysb4AMutFLDo8p1KpDT6jpg";
const FIREBASE_APP_ID = process.env.REACT_APP_FIREBASE_APP_ID || "1:489286790415:web:35a77752dbefad5ad6227a";
const FIREBASE_AUTH_DOMAIN = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "ooca-staging.firebaseapp.com";
const FIREBASE_DATABASE_URL = process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://ooca-staging.firebaseio.com";
const FIREBASE_MESSAGING_SENDER_ID = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "489286790415";
const FIREBASE_PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID || "ooca-staging";
const FIREBASE_PUBLIC_VAPID_KEY = process.env.REACT_APP_FIREBASE_PUBLIC_VAPID_KEY || "BHyhxCQbw4AqnDTtn70XkdogGOKun8vXhQf6WKjL44yLsm_95IZO2tHT3gzBgyrHnY3mO9SfZusB4k3M2Lk0ahc";
const FIREBASE_STORAGE_BUCKET = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "ooca-staging.appspot.com";

const Config = {
	api: {
		host: `${host}`,
		authen: "api/authenticate",
		getMe: "api/users/me",
		getOrganizationByAdmin: "api/admin/organizations",
		getOrganization: "api/organization-admin/organization",
		getChildOrganization: "api/organizations/child",
		editOrganization: "api/organization-admin/organization",
		getAllEmployees: "api/organization-admin/organization/employees",
		addEmployee: "api/organization-admin/organization/employees",
		editEmployee: "api/organization-admin/organization/employees/:id",
		deleteEmployee: "api/organization-admin/organization/employees/:id/delete",
		massDeleteEmployee: "api/organization-admin/organization/delete-employees",
		disableEmployee: "api/organization-admin/organization/employees/:id/disable",
		massDisableEmployee: "api/organization-admin/organization/disable-employees",
		uploadOrganizationBanner: "api/organization-admin/organization/banner",
		importEmployees: "api/organization-admin/organization/import",
		changePassword: "api/password",
		deleteOrganizationCategory: "api/organization-admin/organization/category/:id",
		forgotPassword: "api/forgot-password",
		getOrganizationAppointments: "api/organization-admin/organization/appointments",
		fetchAdmin: "api/organization-admin/organization/admins",
		addAdmin: "api/organization-admin/organization/admins",
		deleteAdmin: "api/organization-admin/organization/admins/",
		fetchOrganizationLogs: "api/organization-admin/organization/logs",
		addOrganizationCategoryChoice: "api/organization-admin/organization/categories/:id",
		editOrganizationCategoryChoice: "api/organization-admin/organization/categories/:id",

		sendInviteEmailToEmployees: "api/organization-admin/organization/invite-emails",
		sendInviteEmailToAllEmployees: "api/organization-admin/organization/invite-emails-all",

		sendStressTestInvite: "api/organization-admin/organization/send-stress-test-invite",
		sendStressTestInviteToAll: "api/organization-admin/organization/send-stress-test-invite-all",
		sendStressTestInviteToRegistered: "api/organization-admin/organization/send-stress-test-invite-all-registerd",
		sendStressTestInviteToNotRegistered: "api/organization-admin/organization/send-stress-test-invite-all-not-registerd",

		// Stress Report
		fetchStressQuestionAndAnswer: "api/organization-admin/organization/stress-test/questions",
		fetchStressChoice: "api/organization-admin/organization/stress-test/choice",
		fetchStressLevel: "api/organization-admin/organization/stress-test/group-by-stress-level",
		fetctStressCategory: "api/organization-admin/organization/stress-test/group-by-category",
		fetchStressAge: "api/organization-admin/organization/stress-test/group-by-age",
		fetchStressGender: "api/organization-admin/organization/stress-test/group-by-gender",
		fetchStressReturning: "api/organization-admin/organization/stress-test/group-by-returning",
		fetchStressOverview: "api/organization-admin/organization/stress-test/overview",
		peopleOverview: "api/organization-admin/organization/people/overview",
		people: "api/organization-admin/organization/people/:id",
		employee: "api/organization-admin/organization/people/:id",

		fetchCounOverview:   "api/organization-admin/organization/counseling/overview",
		fetchCounGender:     "api/organization-admin/organization/counseling/group-by-gender",
		fetchCounProvider:   "api/organization-admin/organization/counseling/group-by-provider",
		fetchCounPlatform:   "api/organization-admin/organization/counseling/group-by-platform",
		fetchCounTopic:      "api/organization-admin/organization/counseling/group-by-topic",
		fetchCounAge:        "api/organization-admin/organization/counseling/group-by-age",
		fetchCounVisitOutcome: "api/organization-admin/organization/counseling/group-by-visit-outcome",
		fetchCounCategory:   "api/organization-admin/organization/counseling/group-by-category",
		fetchCounReturning:  "api/organization-admin/organization/counseling/group-by-returning",
		fetchCounFeedback:   "api/organization-admin/organization/counseling/group-by-feedback",

		fetchStressSelectByFilter: "api/organization-admin/organization/stress-test/select-by-filters",
		fetchStressIndividualByFilter: "api/organization-admin/organization/stress-test/select-by-filters-individual",

		fetchCounSelectByFilter: "api/organization-admin/organization/counseling/select-by-filters",
		fetchCounIndividualByFilter: "api/organization-admin/organization/counseling/select-by-filters-individual",

		// getStressFilterEmployees: "api/organization-admin/organization/counseling/employees",
		// getCounFilterEmployees: "api/organization-admin/organization/counseling/employees",

		exportStressExcel: "api/organization-admin/organization/stress-test/overview/excel",
		exportStressFilterExcel:"api/organization-admin/organization/stress-test/select-by-filters/excel",
		exportCounFilterExcel:"api/organization-admin/organization/counseling/select-by-filters/excel"
	},
	appSetting: {
		productionMode,
	},
	firebase: {
		apiKey: `${FIREBASE_API_KEY}`,
		appId: `${FIREBASE_APP_ID}`,
		authDomain: `${FIREBASE_AUTH_DOMAIN}`,
		databaseUrl: `${FIREBASE_DATABASE_URL}`,
		messagingSenderId: `${FIREBASE_MESSAGING_SENDER_ID}`,
		projectId: `${FIREBASE_PROJECT_ID}`,
		publicVapidKey: `${FIREBASE_PUBLIC_VAPID_KEY}`,
		storageBucket: `${FIREBASE_STORAGE_BUCKET}`,
	},
};
export { host };
export default Config;



// WEBPACK FOOTER //
// ./src/config/index.js